import { useOptionalMeasurements } from '../context/MeasurementContext'
import { formatMeasurement, measurementUnit, parseMeasurementUnit, unitSymbol, type MeasurementQuantity } from '../lib/measurement'

export function useMeasurementPresentation() {
  // Shared read-only views outside the adapted routes retain their historical metric display.
  const { system, locale } = useOptionalMeasurements() ?? { system: 'metric', locale: 'fr-FR' }
  return {
    unit: (quantity: MeasurementQuantity) => unitSymbol(measurementUnit(system, quantity)),
    format: (value: number | string | null | undefined, from: string, quantity: MeasurementQuantity, includeUnit = true) =>
      formatMeasurement(value == null || value === '' || !Number.isFinite(Number(value)) ? null : Number(value), parseMeasurementUnit(from), measurementUnit(system, quantity), { locale, includeUnit }),
  }
}

export function Measure({ value, from, quantity, includeUnit = true }: { value: number | string | null | undefined; from: string; quantity: MeasurementQuantity; includeUnit?: boolean }) {
  const { format } = useMeasurementPresentation()
  return <>{format(value, from, quantity, includeUnit)}</>
}

export function Dimensions({ length, width, height, from = 'mm', quantity = 'cargoLength' }: {
  length?: number | null; width?: number | null; height?: number | null; from?: string; quantity?: 'cargoLength' | 'vehicleLength'
}) {
  const { format, unit } = useMeasurementPresentation()
  if (length == null || width == null || height == null) return <>—</>
  return <>{[length, width, height].map(v => format(v, from, quantity, false)).join(' × ')} {unit(quantity)}</>
}
